module.exports = __webpack_public_path__ + "img/th2024.bdfdae15.png";